import React from "react";
import { BookFormat } from "utils/server-constants/bookFormats";

/**
 * @param {Object} props
 * @param {string} props.format - The book format (digital, physical, or both)
 * @param {string} props.className - Additional CSS classes
 * @returns {React.ReactNode}
 */
const BookFormatLabel = ({ format, className = "" }) => {
	const getFormatLabel = (format) => {
		const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : "");

		if (!format) return [];
		if (format === BookFormat.Both) {
			return [BookFormat.Digital, BookFormat.Physical].map(capitalize);
		}
		return [capitalize(format)];
	};

	return (
		<div
			className={`flex items-center gap-1 ${className}`}
			role="group"
			aria-label="Book format"
		>
			{getFormatLabel(format).map((item) => (
				<span
					key={item}
					className={`text-xs font-medium px-2.5 rounded-full transition-colors duration-200 bg-green-50 text-green-700 border border-green-200 hover:bg-green-100`}
					style={{
						paddingTop: "2px",
						paddingBottom: "2px",
					}}
					aria-label={`${item} format`}
				>
					{item}
				</span>
			))}
		</div>
	);
};

export default BookFormatLabel;
